import { render, staticRenderFns } from "./EntitiesSettings.vue?vue&type=template&id=1b761f51&"
import script from "./EntitiesSettings.vue?vue&type=script&lang=js&"
export * from "./EntitiesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b761f51')) {
      api.createRecord('1b761f51', component.options)
    } else {
      api.reload('1b761f51', component.options)
    }
    module.hot.accept("./EntitiesSettings.vue?vue&type=template&id=1b761f51&", function () {
      api.rerender('1b761f51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/EntitiesSettings.vue"
export default component.exports